import React from "react";
import { constantNoMesin } from "../../util/constant";
import { useNewMemoPPIC } from "./useNewMemoPPIC";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import Select from "react-select";
import DeleteIcon from "../../Assets/delete_icon.png";
import "./MemoPPIC.css";

// Gaya react-select disamakan dengan input lain di tabel
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 34,
    fontSize: 13,
    borderColor: state.isFocused ? "#2d357a" : "#dfe1ee",
    boxShadow: "none",
    "&:hover": { borderColor: "#b9bddb" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
  indicatorsContainer: (base) => ({ ...base, height: 32 }),
  placeholder: (base) => ({ ...base, color: "#1f2340" }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    backgroundColor: state.isSelected
      ? "#2d357a"
      : state.isFocused
      ? "#e8e9f8"
      : "#fff",
    color: state.isSelected ? "#fff" : "#1f2340",
  }),
  menu: (base) => ({ ...base, zIndex: 5 }),
};

const NewMemoPPIC = () => {
  const {
    listProduk,
    addFields,
    memoBahanPokok,
    handleFormChange,
    removeFields,
    handleChangeSubMenu,
    subMenuMemo,
    handleSubmitBahanBaku,
    dateMemoPPIC,
    setDateMemoPPIC,
    popUpMemoPPIC,
    setPopUpMemoPPIC,
    memoGantiUtama,
    handleFormChangeGantiUtama,
    handleSubmitGantiMold,
    handleDeleteMemoGantiMold,
  } = useNewMemoPPIC();

  const sortData =
    memoBahanPokok &&
    memoBahanPokok.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const renderCustomerOptions = (customer) => (
    <>
      {customer === "" ? (
        <option value="Pilih Customer" disabled>
          Pilih Customer
        </option>
      ) : (
        <option value={customer} disabled>
          {customer}
        </option>
      )}
      {listProduk &&
        listProduk.map((data) => (
          <option key={data.company} value={data.company}>
            {data.company}
          </option>
        ))}
    </>
  );

  const renderDatePicker = () => (
    <div className="memo_toolbar">
      <label className="memo_toolbar_label" htmlFor="memo_ppic_date">
        Pilih Tanggal
      </label>
      <input
        id="memo_ppic_date"
        type="date"
        className="date_pick_memo_ppic"
        value={dateMemoPPIC}
        onChange={(e) => setDateMemoPPIC(e.target.value)}
      />
    </div>
  );

  return (
    <div className="container_memo_ppic">
      {popUpMemoPPIC ? (
        <PopUpComponent>
          <p>Terima Kasih! Data Kamu telah di submit!</p>
          <div className="wrapper_button_submit_popup">
            <button
              className="button_popup background_red"
              onClick={() => setPopUpMemoPPIC(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      <div className="memo_header">
        <p className="title_inventory" style={{ margin: 0 }}>
          MEMO PPIC
        </p>
        <div className="memo_tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={subMenuMemo === "BAKU"}
            className={
              subMenuMemo === "BAKU" ? "memo_tab memo_tab_active" : "memo_tab"
            }
            onClick={() => handleChangeSubMenu("BAKU")}
          >
            Memo Produksi
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={subMenuMemo === "GANTI_MOLD"}
            className={
              subMenuMemo === "GANTI_MOLD"
                ? "memo_tab memo_tab_active"
                : "memo_tab"
            }
            onClick={() => handleChangeSubMenu("GANTI_MOLD")}
          >
            Ganti Produksi
          </button>
        </div>
      </div>

      {subMenuMemo === "BAKU" ? (
        <>
          {renderDatePicker()}

          <div className="memo_card">
            <div className="memo_table_wrap">
              <table className="memo_table">
                <thead>
                  <tr>
                    <th className="col_mc">MC</th>
                    <th className="col_cust">Customer</th>
                    <th className="col_mold">Mold</th>
                    <th className="col_warna">Warna</th>
                    <th className="col_bahan">Bahan</th>
                    <th className="col_total">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {sortData && sortData.length > 0 ? (
                    sortData.map((input, index) => (
                      <tr key={index}>
                        <td className="memo_cell_strong">{input.mesin}</td>
                        <td>
                          <select
                            onChange={(e) => handleFormChange(index, e, "BAKU")}
                            className="memo_field"
                            value={
                              input.customer ? input.customer : "Pilih Customer"
                            }
                            name="customer"
                          >
                            {renderCustomerOptions(input.customer)}
                          </select>
                        </td>
                        <td>
                          <div className="select_item_gbj">
                            <Select
                              styles={selectStyles}
                              placeholder={input.moldType}
                              options={input.listMoldProduk}
                              onChange={(e) =>
                                handleFormChange(index, e, "BAKU", "moldType")
                              }
                            />
                          </div>
                        </td>
                        <td>{input.color}</td>
                        <td>{input.material}</td>
                        <td className="memo_cell_num">{input.total} Kg</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="memo_empty" colSpan={6}>
                        Belum ada data untuk tanggal ini.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="memo_actions">
            <button
              type="button"
              className="memo_button memo_button_primary"
              onClick={() => handleSubmitBahanBaku()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : (
        <>
          {renderDatePicker()}

          <div className="memo_card">
            <div className="memo_table_wrap">
              <table className="memo_table">
                <thead>
                  <tr>
                    <th className="col_mc">MC</th>
                    <th className="col_urutan">Urutan</th>
                    <th className="col_jenis">Ganti</th>
                    <th className="col_cust">Cust</th>
                    <th className="col_mold">Mold</th>
                    <th className="col_warna">Warna</th>
                    <th className="col_bahan">Material</th>
                    <th className="col_order">Order</th>
                    <th className="col_aksi">
                      <span
                        className="sr_only"
                        style={{ position: "absolute", left: "-9999px" }}
                      >
                        Hapus
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {memoGantiUtama && memoGantiUtama.length > 0 ? (
                    memoGantiUtama.map((input, index) => (
                      <tr key={index}>
                        <td>
                          <select
                            onChange={(e) =>
                              handleFormChangeGantiUtama(index, e, "")
                            }
                            className="memo_field"
                            name="mesin"
                            value={input.mesin}
                          >
                            <option selected disabled>
                              Pilih Nomor Mesin
                            </option>
                            {constantNoMesin &&
                              constantNoMesin.map((data) => (
                                <option key={data} value={data}>
                                  {data}
                                </option>
                              ))}
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            onChange={(e) =>
                              handleFormChangeGantiUtama(index, e, "")
                            }
                            className="memo_field"
                            name="urutan"
                            placeholder="Urutan"
                            value={input.urutan}
                          />
                        </td>
                        <td>
                          <select
                            onChange={(e) =>
                              handleFormChangeGantiUtama(index, e, "")
                            }
                            className="memo_field"
                            value={input.jenis ? input.jenis : "Pilih Jenis"}
                            name="jenis"
                          >
                            <option value="Pilih Jenis" disabled>
                              Pilih Jenis
                            </option>
                            <option value="INSERT">INSERT</option>
                            <option value="MOLD">MOLD</option>
                            <option value="NAMABARANG">NAMA BARANG</option>
                            <option value="WARNA">WARNA</option>
                          </select>
                        </td>
                        <td>
                          <select
                            onChange={(e) =>
                              handleFormChangeGantiUtama(index, e, "")
                            }
                            className="memo_field"
                            value={
                              input.customer ? input.customer : "Pilih Customer"
                            }
                            name="customer"
                          >
                            {renderCustomerOptions(input.customer)}
                          </select>
                        </td>
                        <td>
                          <div className="select_item_gbj">
                            <Select
                              styles={selectStyles}
                              placeholder={input.moldProduk}
                              options={input.listMoldProduk}
                              onChange={(e) =>
                                handleFormChangeGantiUtama(
                                  index,
                                  e,
                                  "BAKU",
                                  "moldType"
                                )
                              }
                            />
                          </div>
                        </td>
                        <td>{input.color}</td>
                        <td>{input.material}</td>
                        <td>
                          <div className="memo_order_wrap">
                            <input
                              type="number"
                              onChange={(e) =>
                                handleFormChangeGantiUtama(index, e, "")
                              }
                              className="memo_field"
                              name="totalBahan"
                              placeholder="Total"
                              value={
                                input.totalBahan ? input.totalBahan : "Total"
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                            <span>Pcs</span>
                          </div>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="memo_icon_button"
                            aria-label="Hapus baris"
                            onClick={() => handleDeleteMemoGantiMold(input)}
                          >
                            <img src={DeleteIcon} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="memo_empty" colSpan={9}>
                        Belum ada baris. Klik Tambah untuk membuat baris baru.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="memo_actions">
            <div className="memo_actions_group">
              <button
                type="button"
                className="memo_button memo_button_outline"
                onClick={() => addFields("SATUAN", "UTAMA")}
              >
                Tambah
              </button>
              <button
                type="button"
                className="memo_button memo_button_outline"
                onClick={() => removeFields("SATUAN", "UTAMA")}
              >
                Kurang
              </button>
            </div>
            <button
              type="button"
              className="memo_button memo_button_primary"
              onClick={() => handleSubmitGantiMold()}
            >
              Kirim
            </button>
          </div>
        </>
      )}
    </div>
  );
};
export default NewMemoPPIC;
